import styled, { css } from "styled-components";

const commonStyles = css`
  display: contents;
  .containerCupom {
    padding: 0 10%;
    width: 100rem;
    max-width: 90vw;
    position: relative;
    
    @media (max-width: 768px) {
      padding: 0 5%;
      width: 100%;
      max-width: 95vw;
    }
    
    .inputContainer {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 0rem 0 4rem 0;
      gap: 1rem;

      @media (max-width: 768px) {
        padding: 0rem 0 2rem 0;
        gap: 1.5rem;
      }

      .flex {
        width: 100%;        
        flex-direction: row;
        label {
          display: flex;
          gap: 1rem;
          align-items: center;
          flex-wrap: wrap;
          
          @media (max-width: 768px) {
            gap: 0.5rem;
          }
        }
        .tipoDescontoLabel {
          margin: 1rem 0;
          
          @media (max-width: 768px) {
            margin: 0.5rem 0;
          }
        }
        .tipoDescontoRadios {
          display: flex;
          flex-direction: row;
          justify-content: start;
          gap: 5rem;
          margin-bottom: 1rem;
          
          @media (max-width: 768px) {
            margin-bottom: 0.5rem;
          }
        }
        .tipoDescontoRadios label {
          cursor: pointer;
          display: flex;
          flex-direction: row-reverse;
          justify-content: flex-end;
          margin: 0.2rem 0;
        }
      }

      .configuracoesAvancadas{
        display: grid;
        grid-template-columns: repeat(2,1fr);
        gap: 2rem;
        width: 100%;
        justify-content: space-between;
        padding-top: 2rem;
        @media (max-width: 768px) {
          grid-template-columns: 1fr;
        }

        .agendarExpiracao{
          display: flex;
          flex-direction: column;
          gap: 1rem;
          label{
            display: flex;
            gap: 1rem;
          }

          .expiracao {
            display: block;
            transition: 0.3s ease-in-out;
            pointer-events: none;
            opacity: 0;
            transform: translateY(-10px);
          }

          .ativo {
            pointer-events: inherit;
            opacity: 1;
            transform: translateY(0);
          }
        }

        .limitarUso{
          display: flex;
          flex-direction: column;
          gap: 1rem;
          label{
            display: flex;
            gap: 1rem;
          }

          .expiracao {
            display: block;
            transition: 0.3s ease-in-out;
            pointer-events: none;
            opacity: 0;
            transform: translateY(-10px);
          }

          .ativo {
            pointer-events: inherit;
            opacity: 1;
            transform: translateY(0);
          }
        }
      }

      &::after {
        content: "";
        position: absolute;
        width: 35rem;
        height: 2px;
        border-radius: 50px;
        background-color: ${(props) => props.theme.colors.elements};
        bottom: 0;
        
        @media (max-width: 768px) {
          width: 90%;
          left: 5%;
        }
      }
    }

    .containerToggles {
      padding: 4rem 0 0rem 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      @media (max-width: 768px) {
        padding: 2rem 0 0rem 0;
      }

      .containerTogglesInner {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        
        @media (max-width: 768px) {
          gap: 1rem;
          width: 100%;
        }
        
        .toggleConfigurar {
          .nome {
            color: ${(props) => props.theme.colors.tertiary};
            
            @media (max-width: 768px) {
              font-size: 1.4rem;
            }
          }
        }
      }
    }

    .exclusao {
      margin-top: 4rem;
      padding: 4rem 0;
      color: ${(props) => props.theme.colors.primary};
      cursor: pointer;
      
      @media (max-width: 768px) {
        margin-top: 2rem;
        padding: 2rem 0;
      }
    }
  }
`;

export const ContainerCupom = styled.div<{
  configIn: "empresa" | "configuracoes";
}>`
  ${commonStyles}
  ${({ configIn }) =>
    configIn === "configuracoes" &&
    css`
      .containerCupom {
        width: 100%;
        max-width: none;
        padding: 3rem 0;
        
        @media (max-width: 768px) {
          padding: 2rem 0;
        }
        
        .inputContainer {
          width: 100%;
          padding: 0;
          
          @media (max-width: 768px) {
            gap: 1rem;
          }
          
          &::after {
            display: none;
          }
        }
        .containerToggles {
          flex-direction: row;
          
          @media (max-width: 768px) {
            flex-direction: column;
            align-items: stretch;
          }
          
          .containerTogglesInner {
            flex-direction: row;
            
            @media (max-width: 768px) {
              flex-direction: column;
              gap: 1rem;
            }
            
            .toggleConfigurar {
              .nome {
                width: auto;
                margin-right: 1rem;
                
                @media (max-width: 768px) {
                  margin-right: 0;
                  margin-bottom: 0.5rem;
                }
              }
            }
          }
        }
        .exclusao {
          margin-top: 0;
          padding: 2rem 0 0 0;
          text-align: center;
          
          @media (max-width: 768px) {
            padding: 1.5rem 0 0 0;
          }
        }
      }
    `}
`;

